import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "table1"
};
const _hoisted_2 = {
  style: {
    "margin-top": "10px"
  }
};
import { ref, computed, watch } from 'vue';
import { ApplyType, applicationStatus, approvalStatus } from '../config';
import { indexMethod } from '@/utils/indexMethod';
import { getUserApprovalList } from '@/api/user';
import { useStore } from 'vuex';
export default {
  __name: 'table',
  props: {
    data: {
      type: Array
    },
    page: {
      type: Number
    },
    size: {
      type: Number
    },
    total: {
      type: Number
    },
    loading: {
      type: Boolean,
      default: false
    },
    schema: {
      type: Array,
      default: () => []
    },
    approvalType: {
      type: Number,
      required: true
    }
  },
  emits: ['delUserHandler', 'handleCurrentChange', 'updateUserHandler', 'approval', 'confirm', 'reject', 'selection'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const handleSelectionChange = val => {
      emit('selection', val);
    };
    const userArr = ref([]);
    const _getUserApprovalList = async () => {
      const res = await getUserApprovalList({
        type: props.approvalType
      });
      userArr.value = res.records.map(item => item.auditorId);
    };
    const checkSelectable = row => {
      var _store$getters, _store$getters2;
      return ((_store$getters = store.getters) === null || _store$getters === void 0 || (_store$getters = _store$getters.userInfo) === null || _store$getters === void 0 || (_store$getters = _store$getters.sysUser) === null || _store$getters === void 0 ? void 0 : _store$getters.id) && userArr.value.includes((_store$getters2 = store.getters) === null || _store$getters2 === void 0 || (_store$getters2 = _store$getters2.userInfo) === null || _store$getters2 === void 0 || (_store$getters2 = _store$getters2.sysUser) === null || _store$getters2 === void 0 ? void 0 : _store$getters2.id) && (row['applyStatus'] === 1 || row['applyStatus'] === 3) && row['finalStatus'] === 1 && row['approvalStatus'] === 1;
    };
    watch(() => props.approvalType, val => {
      _getUserApprovalList();
    }, {
      immediate: true,
      deep: true
    });
    const store = useStore();
    const isApprovalBtnVisible = computed(() => {
      return item => {
        var _store$getters3, _store$getters4;
        return ((_store$getters3 = store.getters) === null || _store$getters3 === void 0 || (_store$getters3 = _store$getters3.userInfo) === null || _store$getters3 === void 0 || (_store$getters3 = _store$getters3.sysUser) === null || _store$getters3 === void 0 ? void 0 : _store$getters3.id) && userArr.value.includes((_store$getters4 = store.getters) === null || _store$getters4 === void 0 || (_store$getters4 = _store$getters4.userInfo) === null || _store$getters4 === void 0 || (_store$getters4 = _store$getters4.sysUser) === null || _store$getters4 === void 0 ? void 0 : _store$getters4.id) && (item['applyStatus'] === 1 || item['applyStatus'] === 3) && item['finalStatus'] === 1 && item['approvalStatus'] === 1;
      };
    });
    const handleCurrentChange = val => {
      emit('handleCurrentChange', val);
    };
    const handleToApproval = row => {
      emit('approval', row);
    };
    const handleToConfirm = row => {
      emit('confirm', row);
    };
    const handleToReject = row => {
      emit('reject', row);
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: __props.data,
        border: "",
        style: {
          "width": "100%"
        },
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          selectable: checkSelectable,
          width: "55"
        }), _createVNode(_component_el_table_column, {
          label: "#",
          type: "index",
          index: index => _unref(indexMethod)(index, __props.page, __props.size)
        }, null, 8, ["index"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.schema, item => {
          return _openBlock(), _createBlock(_component_el_table_column, {
            key: item.prop,
            prop: item.prop,
            label: item.label,
            "min-width": item.minWidth
          }, {
            default: _withCtx(({
              row
            }) => [item.prop === 'applyStatus' && row[item.prop] ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: row[item.prop] !== 1 ? 'danger' : row[item.prop] !== 2 ? 'success' : ''
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(applicationStatus)[row[item.prop]]), 1)]),
              _: 2
            }, 1032, ["type"])) : item.prop === 'applyApprovalType' ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 1
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(ApplyType)[row[item.prop]]), 1)]),
              _: 2
            }, 1024)) : item.prop === 'approvalStatus' ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 2,
              type: row[item.prop] === 3 ? 'danger' : 'success'
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(approvalStatus)[row[item.prop]]), 1)]),
              _: 2
            }, 1032, ["type"])) : item.prop === 'operName' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 3
            }, [_createTextVNode(" -- ")], 64)) : item.prop === 'approvalTime' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 4
            }, [_createTextVNode(_toDisplayString(!row[item.prop] ? '暂未审批' : row[item.prop]), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 5
            }, [_createTextVNode(_toDisplayString(row[item.prop]), 1)], 64))]),
            _: 2
          }, 1032, ["prop", "label", "min-width"]);
        }), 128)), _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "220"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => handleToApproval(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 详情 ")]),
            _: 2
          }, 1032, ["onClick"]), isApprovalBtnVisible.value(row) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "success",
            size: "small",
            onClick: $event => handleToConfirm(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 通过 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), isApprovalBtnVisible.value(row) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "danger",
            size: "small",
            onClick: $event => handleToReject(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 拒绝 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, __props.loading]]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_pagination, {
        class: "pagination",
        onCurrentChange: handleCurrentChange,
        "current-page": __props.page,
        "page-size": __props.size,
        layout: "total,  prev, pager, next, jumper",
        total: __props.total
      }, null, 8, ["current-page", "page-size", "total"])])]);
    };
  }
};